import { render } from "./BusinessProtectionExpressQuestion.vue?vue&type=template&id=4f676176&scoped=true"
import script from "./BusinessProtectionExpressQuestion.vue?vue&type=script&lang=js"
export * from "./BusinessProtectionExpressQuestion.vue?vue&type=script&lang=js"

import "./BusinessProtectionExpressQuestion.vue?vue&type=style&index=0&id=4f676176&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f676176"]])

export default __exports__